import { useMemo } from 'preact/hooks';

export default function useUniqueId() {
  const uniqueId = useMemo(() => crypto.randomUUID(), []);

  return uniqueId;
}
